/**
 * Converts the specified date to an YYYY-MM-DD ISO-8601 string format.
 * This is compatible with the AWSDate scalar type in AppSync.
 * @param date The date to convert, otherwise defaults to new Date().
 * @returns string A YYYY-MM-DD string format.
 */
export function dateToDateString(date: Date = new Date()): string {
  return date.toISOString().substring(0, 10);
}

/**
 * Converts the specified date to an YYYY-MM-DDThh:mm:ss.sssZ ISO-8601 string format.
 * This is compatible with the AWSDateTime scalar type in AppSync.
 * @param date The date to convert, otherwise defaults to new Date().
 * @returns string A YYYY-MM-DDThh:mm:ss.sssZ string format.
 */
export function dateToDateTimeString(date: Date = new Date()): string {
  return date.toISOString();
}
